// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1wSX2","inputWrap":"CustomTip_inputWrap__1pOJb"};